import { styled } from "@mui/material";
import { Divider } from "@mui/material";

interface StyledDividerProps {
  color: "light" | "dark";
}

export const StyledDivider = styled(Divider)<StyledDividerProps>`
  && {
    margin: 0;
    border-width: 0;
    border-style: solid;
    border-color: ${(props) =>
      props.theme.wsc.palette.neutral[props.color === "light" ? 400 : 500]};
    ${(props) =>
      props.orientation === "vertical"
        ? `border-bottom-width: 0;height: auto;border-right-width: thin;`
        : `border-bottom-width: thin;`}
  }
`;
